import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Custom from "../../../Components/Buttons/Custom";
import { displayNumToNum } from "../../../helper/displayNumToNum";
import ProfitGrid from "./ProfitGrid";
import ProfitTable from "./ProfitTable";
import WithdrawModal from "./WithdrawModal";

const getPayoutLockTooltip = (cannotPayoutBecause) => {
  const reasons = Array.isArray(cannotPayoutBecause)
    ? cannotPayoutBecause
    : [];

  if (reasons.length === 1 && reasons[0] === "open_trades") {
    return "برای برداشت، نباید پوزیشن و سفارش فعالی داشته باشید";
  }

  return "مجاز نیست؛ به قوانین برداشت مراجعه کنید";
};

export default function Profit({ payoutData, accLoading }) {
  const navigate = useNavigate();
  const [isWithdrawOpen, setIsWithdrawOpen] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [activeFilter] = useState(() =>
    window.innerWidth >= 480 ? [false, true] : [true, false],
  );

  const payoutRows =
    payoutData && payoutData.accounts
      ? payoutData.accounts.map((account) => {
          const profitAvailable =
            account.can_payout && payoutData.role === "trader_verified"
              ? `$${Number(account.available_for_payout).toLocaleString()}`
              : "$0";
          const cannotPayoutBecause = account.cannot_payout_because;

          return {
            uuid: account.account_code,
            id: account.account_id,
            role: payoutData.role,
            cannotPayoutBecause,
            accountType: `${account.category} | ${account.name}`,
            accountProfit:
              Number(account.account_pnl) >= 0
                ? `$${Number(account.account_pnl).toLocaleString()}`
                : `-$${Number(-1 * account.account_pnl).toLocaleString()}`,
            profitAvailable,
            processTime: "۱ روز کاری",
            isLocked:
              Number(displayNumToNum(profitAvailable)) <= 0 ||
              payoutData.role === "trader",
            lockReason: getPayoutLockTooltip(cannotPayoutBecause),
          };
        })
      : [];

  const displayedRows = [
    ...payoutRows,
  ];

  const openWithdrawModal = (row) => {
    setSelectedAccount(Number(row.id));
    setIsWithdrawOpen(true);
  };

  return (
    <div className="w-full p-5 flex flex-col gap-5 rounded-2xl bg-zi-bg2-light dark:bg-zi-bg2-dark">
      <div className="w-full flex items-center justify-between">
        <h3 className="text-lg font-medium text-zi-text-light dark:text-zi-text-dark">
          برداشت سود
        </h3>

        <Custom
          onClick={() => navigate("/rule/withdraw")}
          text="قوانین برداشت"
          href=""
          className="bg-transparent !px-2.5 !py-1.5 mb:!px-5 mb:!py-2 !rounded-lg mb:!rounded-lg text-zi-text-light dark:text-zi-text-dark border border-zi-border-dark dark:border-zi-border-light/50 hocus:ring-1 hocus:ring-inset hocus:ring-zi-border-dark hocus:dark:ring-zi-border-light/50 text-xs mb:text-sm"
        />
      </div>

      {activeFilter[0] && (
        <ProfitGrid
          rows={displayedRows}
          accLoading={accLoading}
          onWithdraw={openWithdrawModal}
        />
      )}
      {activeFilter[1] && (
        <ProfitTable
          rows={displayedRows}
          accLoading={accLoading}
          onWithdraw={openWithdrawModal}
        />
      )}

      {isWithdrawOpen && (
        <div
          className="w-full fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur"
          onClick={() => setIsWithdrawOpen(false)}
        >
          <div
            className="w-11/12 max-w-md flex justify-center"
            onClick={(event) => event.stopPropagation()}
          >
            <WithdrawModal
              setIsWithdrawOpen={setIsWithdrawOpen}
              accountId={selectedAccount}
            />
          </div>
        </div>
      )}
    </div>
  );
}
